import React, { useContext, useEffect, useState } from 'react';

import { Check } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { gray100, primaryButtonOutlinedColor } from '../../../constants/Colors';
import { headerHeight, spHeaderHeight } from '../../../constants/Location';
import { AuthContext } from '../../../contexts/auth';
import { browserBack } from '../../../modules/error';
import CustomSnackbar from '../../uiParts/CustomSnackbar';
import Header from '../../uiParts/Header';
import CustomHead from '../CustomHead';

const styles = {
  checkIcon: {
    '@media screen and (max-width:600px)': {
      fontSize: '64px'
    },
    fontSize: '80px',
    width: '100%'
  },
  container: {
    '@media screen and (max-width:600px)': {
      height: `calc( 100vh - ${spHeaderHeight} - 64px)`,
      m: `${spHeaderHeight} auto 0`,
      pt: '64px',
      width: '90%'
    },
    height: `calc( 100vh - ${headerHeight} - 96px )`,
    m: `${headerHeight} auto 0`,
    pt: '96px',
    width: '560px'
  },
  text: {
    color: gray100,
    mt: '24px',
    textAlign: 'center'
  },
  primaryButtonOutlinedColor,
  title: {
    color: gray100,
    fontSize: '24px',
    fontWeight: '500',
    mt: '16px',
    textAlign: 'center'
  }
};

const MakerApplyComplete: React.FC = () => {
  const navigate = useNavigate();
  const [errorText, setErrorText] = useState('');
  const [finishStatus, setfinishStatus] = useState(false);
  const [open, setOpen] = useState(false);

  // ブラウザバック時のアラート
  const browserBackAlert = (e: { preventDefault: () => void }): void => {
    if (!finishStatus) {
      e.preventDefault();
      setOpen(true);
      setErrorText(browserBack);
      window.history.pushState(null, '', window.location.pathname);
      setfinishStatus(false);
    }
  };

  // ブラウザバック防止
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', browserBackAlert);
    return () => {
      window.removeEventListener('popstate', browserBackAlert);
    };
  }, []);

  // 未ログイン時はログイン画面に飛ばす
  const { checkLoginStatus } = useContext(AuthContext);
  useEffect(() => {
    void (async () => {
      if (!checkLoginStatus) return navigate('/auth/login');
      const result = await checkLoginStatus();
      if (!result.check) return navigate('/auth/login');
    })();
  }, [checkLoginStatus]);

  return (
    <>
      <CustomHead title="建材登録会員 申し込み完了 | CMCOS[コムコス]" />
      <Header />
      <Typography component="div" sx={styles.container}>
        <Check sx={styles.checkIcon} />
        <Typography sx={styles.title}>
          建材登録会員へのお申し込みが完了しました
        </Typography>
        <Typography sx={styles.text}>
          回答まで3営業日ほどお待ち下さい。
          <br />
          回答はメールでお送りいたします。
        </Typography>
        <Button
          fullWidth
          onClick={() => {
            navigate('/account');
          }}
          sx={[styles.primaryButtonOutlinedColor, { mt: '80px' }]}
          variant="outlined"
        >
          戻る
        </Button>
        <CustomSnackbar
          open={open}
          autoHideDuration={6000}
          onClose={() => setOpen(false)}
          text={errorText}
        />
      </Typography>
    </>
  );
};

export default MakerApplyComplete;
